/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectorRef,
  Directive,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import * as Feather from 'feather-icons';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[data-feather]',
  standalone: false
})
export class FeatherIconDirective implements OnChanges {
  private _nativeElement: any;

  @Input('data-feather') name!: string;
  @Input() class!: string;
  @Input() size!: string;
  @Input() inner!: boolean;

  constructor(
    @Inject(ElementRef) private _elementRef: ElementRef,
    @Inject(ChangeDetectorRef) private _changeDetector: ChangeDetectorRef
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    this._nativeElement = this._elementRef.nativeElement;

    this.name = changes['name'] ? changes['name'].currentValue : '';
    this.size = changes['size'] ? changes['size'].currentValue : '14'; // Set default size 14
    this.class = changes['class'] ? changes['class'].currentValue : '';

    const svg = Feather.icons[this.name as Feather.FeatherIconNames].toSvg({
      class: this.class,
      width: this.size,
      height: this.size,
    });

    if (this.inner) {
      this._nativeElement.innerHTML = svg;
    } else {
      this._nativeElement.outerHTML = svg;
    }
    this._changeDetector.markForCheck();
  }
}
